import { render, staticRenderFns } from "./hotelStatistics.vue?vue&type=template&id=5e2455a8&scoped=true&"
import script from "./hotelStatistics.vue?vue&type=script&lang=js&"
export * from "./hotelStatistics.vue?vue&type=script&lang=js&"
import style0 from "./hotelStatistics.vue?vue&type=style&index=0&id=5e2455a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2455a8",
  null
  
)

export default component.exports